import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from "axios";

export const getRoutes = createAsyncThunk(
  'routes/getRoutes',
  async ({ id }) => {
    return fetch(
      `${process.env.REACT_APP_BASE_URL}client/list-routes?id=${id}`,{
        method:'GET',
        headers:{
          'Authorization':id, 
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
    ).then((res)=>res.json()).catch((error)=> error)
  }
)

const ApiRoutesSlice = createSlice({
  name: 'routes',
  initialState: {
    list: [],
    status: null,
  },
  extraReducers: {
    [getRoutes.pending]: (state, action) => {
      state.status = 'loading'
    },
    [getRoutes.fulfilled]: (state, { payload }) => {
      state.list = payload
      state.status = 'success'
    },
    [getRoutes.rejected]: (state, action) => {
      state.status = 'failed'
    },
  },
})

export default ApiRoutesSlice.reducer
